<template>
  <div class="buyList">
    <div v-for="(bItem,bIndex) in buyList" :key="bIndex" :class="['item',bItem.freeFlag?'free':(showOther?'plan otherPlan':'plan')]">
      <div v-if="!bItem.freeFlag" class="recommended light-1">
        <div class="recommended-text">👍Recommended</div>
      </div>
      <div class="item-title white">{{ bItem.goodsname }}</div>
      <div class="item-price white">
        <!-- 免费-->
        <template v-if="bItem.freeFlag">
          <div class="item-price-amount">FREE</div>
        </template>
        <template v-else>
          <div class="item-price-amount">
            ${{ bItem.price }}
            <!-- 默认启动自动续费开关  显示现价-->
            <!--            <template v-if="bItem.renewalFlag">${{ bItem.price }}</template>-->
            <!--            &lt;!&ndash; 未启动自动续费开关  显示原价&ndash;&gt;-->
            <!--            <template v-else>${{ bItem.originalprice }}</template>-->
          </div>
          <div class="item-price-unit">/ {{ bItem.skuname }}</div>
        </template>
      </div>
      <div class="item-desc light-color-5">{{ bItem.desc }}</div>
      <el-button :class="['item-btn',bItem.freeFlag?'free-btn':'gradient-btn']" @click="upgradePlan(bItem)">
        {{ bItem.buttonText }}
      </el-button>
      <div class="details">
        <div class="details-item" v-for="(dItem,dIndex) in bItem.detailsList" :key="dIndex">
          <i v-if="dItem.errFlag" class="el-icon-close"></i>
          <div v-else class="details-item-tick">
            <img :src="`${$g.imgPrefix}/img/shareAI/tick.svg`" alt="">
          </div>
          <div class="details-item-text light-color-5">{{ dItem.text }}</div>
        </div>
      </div>
      <!-- 默认启用自动续订-->
      <!--      <div v-if="!bItem.freeFlag" class="switch">-->
      <!--        <div class="switch-label light-color-5">Enable auto-renewal</div>-->
      <!--        <el-switch v-model="bItem.renewalFlag"></el-switch>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import {
  formatObj,
  MessageError,
  isEmpty,
  filterObjGetIndex
} from "@/util/util"
import {
  getGoodsspuAll
} from "@/request/requests";
import {
  mapMutations
} from 'vuex';
export default {
  name: "buyNowList",
  props:{
    showOther:Boolean
  },
  data() {
    return {
      buyList: [],
      partList: [
        //Free 固定显示
        {
          //是否免费
          freeFlag: true,
          //右上角推荐
          recommandFlag: false,
          goodsname: 'Free Plan',
          //现价
          price: 'FREE',
          desc: 'Only 5 quotas available per day.',
          buttonText: 'Your current plan',
          detailsList: [
            {
              errFlag: true,
              text: 'AI Chat Free Model: Quota Required',
            },
            // {
            //   errFlag: true,
            //   text: 'Midjourney Relax Mode: Not Available',
            // },
            {
              errFlag: true,
              text: 'Response speed: Standard.',
            },
            {
              errFlag: true,
              text: 'Availability: May be limited during peak hours.',
            },
            {
              errFlag: true,
              text: 'Customer support: None.'
            }
          ]
        }
      ],
      allList:[],
      selfObj: {
        //是否免费
        freeFlag: false,
        //右上角推荐
        recommandFlag: true,
        //产品名
        goodsname: '',
            //'Pro Plan',
        desc: 'Extend usage permissions to improve efficiency.',
        buttonText: 'Upgrade plan',
        detailsList: [
          {
            errFlag: false,
            text: 'AI Chat Free Model: Unlimited Use'
          },
          // {
          //   errFlag: false,
          //   text: 'Midjourney Relax Mode: Unlimited Use'
          // },
          {
            errFlag: false,
            text: '1500 Quotas per month'
          },
          {
            errFlag: false,
            text: 'Response speed: Fastest.'
          },
          {
            errFlag: false,
            text: 'Availability: Priority access.'
          },
          {
            errFlag: false,
            text: 'Customer support: 24/7 support.'
          }
        ]
      },
      aiIndex:''
    }
  },
  computed:{
    spuList: {
      get(){
        return this.$store.state.shareAI.spuList;
      },
      set(val){
        this.$store.commit('shareAI/SET_SPU_LIST',val);
      }
    }
  },
  methods: {
    ...mapMutations({
      SET_UPGRADE_DISABLED:'shareAI/SET_UPGRADE_DISABLED'
    }),
    async init() {
      await this.getGoodsspuAllInfo();
      await this.getPartList();
      if(isEmpty(this.buyList)) {
        this.SET_UPGRADE_DISABLED(true);
      }else{
        this.SET_UPGRADE_DISABLED(false);
      }
    },
    getPartList(){
      return new Promise((resolve,reject)=>{
        this.buyList = [];
        this.partList.splice(1,1);
        //暂时先取spuList[0]，后续下标要改
        let skusObj = formatObj(this.spuList[this.aiIndex]?.skus[0]);
        this.$set(this.selfObj,'goodsname',this.spuList[this.aiIndex]?.goodsname);
        let temp = {
          ...skusObj,
          ...this.selfObj
        }
        this.$set(this.partList, this.partList.length, temp);
        this.buyList = this.partList;
        resolve();
      })
    },
    getAllList(){
      this.buyList = [];
      this.allList = formatObj(this.spuList[this.aiIndex]?.skus);
      if(!isEmpty(this.allList)){
        this.allList = this.allList.map((item)=>{
          return item = {
            ...item,
            ...this.selfObj
          }
        })
      }
      this.buyList = this.allList;
    },
    getGoodsspuAllInfo() {
      return new Promise((resolve,reject)=>{
        getGoodsspuAll().then(res=>{
          if (res.status == "200") {
            this.spuList = res?.data;
            if(isEmpty(this.spuList)) {
              reject();
              return;
            }
            this.spuList.forEach(sItem=>{
              if(!isEmpty(sItem.skus)){
                sItem.skus.forEach(skuItem=>{
                  this.$set(skuItem,'goodsname',sItem.goodsname);
                })
              }
            })



            // 找到 id 为 x 的项目
            let itemToMove = this.spuList.find(item => item.id === 11);
            if (itemToMove) {
              // 从原列表中移除该项目
              this.spuList = this.spuList.filter(item => item.id !== 11);
              // 如果登录 将该项目插入到列表的第二个位置（索引 1 处）
              let token = this.$cookies.get('token');
              if (token) {
                this.spuList.splice(1, 0, itemToMove);
              }
            }

            this.aiIndex = filterObjGetIndex(this.spuList,'goodsname','share ai');
            console.log(this.aiIndex);
            resolve();
          } else {
            MessageError(res.msg);
            reject();
          }
        });
      })
    },
    upgradePlan(bItem) {
      if (bItem.freeFlag) return;
      let form1 = {
        buytype:'1',
        goodsid: bItem.goodsid,
        //description: bItem.goodsname + bItem.price + bItem.skuname,
        discountcode:'',
        num:1,
        skuid: bItem.id,
      }
      this.$emit('goPay', formatObj(bItem),formatObj(form1));
    },
    reset(){
      this.buyList = [];
      this.partList.splice(1,1);
      this.allList = [];
    },

  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/buyNow.scss";
</style>